export function normalizeDatePasteValue(value: string) {
  const trimmedValue = value.trim().replace(/\r$/, '')

  if (!trimmedValue) {
    return trimmedValue
  }

  const parsedTimestamp = Date.parse(trimmedValue)

  if (Number.isNaN(parsedTimestamp)) {
    return trimmedValue
  }

  const parsedDate = new Date(parsedTimestamp)
  const year = parsedDate.getFullYear().toString().padStart(4, '0')
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0')
  const day = parsedDate.getDate().toString().padStart(2, '0')

  return `${year}-${month}-${day}`
}
